module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "MayTheForceBeWithYou",
	"sourceName": "contracts/levels/MayTheForceBeWithYou.sol",
	"abi": [
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_underlying",
					"type": "address"
				}
			],
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "owner",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "spender",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "Approval",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "beneficiary",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "Deposit",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "from",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "value",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "beneficiary",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "Withdraw",
			"type": "event"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "owner",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "spender",
					"type": "address"
				}
			],
			"name": "allowance",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "spender",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "approve",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "account",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "decimals",
			"outputs": [
				{
					"internalType": "uint8",
					"name": "",
					"type": "uint8"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "spender",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "subtractedValue",
					"type": "uint256"
				}
			],
			"name": "decreaseAllowance",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "deposit",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "spender",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "addedValue",
					"type": "uint256"
				}
			],
			"name": "increaseAllowance",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "name",
			"outputs": [
				{
					"internalType": "string",
					"name": "",
					"type": "string"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "symbol",
			"outputs": [
				{
					"internalType": "string",
					"name": "",
					"type": "string"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "recipient",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "transfer",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "sender",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "recipient",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "amount",
					"type": "uint256"
				}
			],
			"name": "transferFrom",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "uint256",
					"name": "numberOfShares",
					"type": "uint256"
				}
			],
			"name": "withdraw",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "yoda",
			"outputs": [
				{
					"internalType": "contract MiniMeToken",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/MayTheForceBeWithYou.sol/MayTheForceBeWithYou.json
// module id = 1583
// module chunks = 0